// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2C5sM","title":"ClientInsurance_title__28X1S","itemText":"ClientInsurance_itemText__2Hpyl"};